"use client";

import { graphql } from "gql.tada";
import { useQuery } from "urql";
import { SidebarMenuBadge } from "@/components/ui/sidebar";

const UnreadNotificationCountQuery = graphql(`
  query UnreadNotificationCount($organizationID: ID!) {
    viewer {
      id
      notifications(
        organizationID: $organizationID
        archived: false
        unread: true
        first: 1 # 0だとエラーになる
      ) {
        totalCount
      }
    }
  }
`);

interface InboxCountBadgeProps {
  workspaceId: string;
}

export function InboxCountBadge({ workspaceId }: InboxCountBadgeProps) {
  const [{ data }] = useQuery({
    query: UnreadNotificationCountQuery,
    variables: {
      organizationID: decodeURIComponent(workspaceId),
    },
  });

  const inboxCount = data?.viewer?.notifications?.totalCount ?? 0;

  if (inboxCount === 0) {
    return null;
  }

  const displayCount = inboxCount > 99 ? "99+" : inboxCount;

  return <SidebarMenuBadge>{displayCount}</SidebarMenuBadge>;
}
